import type { PropsWithChildren } from 'react';
import React, { createContext, useContext, useState } from 'react';

interface BulkBiddingModalContextProps {
	handleCloseModal: () => void;
	handleOpenModal: () => void;
	isModalOpen: boolean;
}

const BulkBiddingModalContext = createContext<BulkBiddingModalContextProps | undefined>(undefined);

export const BulkBiddingModalProvider: React.FC<PropsWithChildren> = ({ children }) => {
	const [isModalOpen, setIsModalOpen] = useState(false);

	const handleOpenModal = () => setIsModalOpen(true);
	const handleCloseModal = () => setIsModalOpen(false);

	return (
		<BulkBiddingModalContext.Provider value={{ handleCloseModal, handleOpenModal, isModalOpen }}>
			{children}
		</BulkBiddingModalContext.Provider>
	);
};

export const useBulkBiddingModal = () => {
	const context = useContext(BulkBiddingModalContext);
	if (!context) {
		throw new Error('useBulkBiddingModal must be used within BulkBiddingModalProvider');
	}
	return context;
};
